import Network from '@/Network'
import { AuthorizationResourcesAndSubjects, AuthorizationRelations } from '@/types/authorization'
import { UpsertPermissionsRequest } from '@/Network/Types/Requests/AuthorizationRequests'
import { ModuleTypeStrategy, PermissionOption } from './ModuleTypeStrategy'

const PERMISSIONS_FOR_NEW_USERS: PermissionOption[] = [
  { label: 'Extrator', value: AuthorizationRelations.Extractor },
  { label: 'Emissor', value: AuthorizationRelations.Emitter },
  { label: 'Receptor Básico', value: AuthorizationRelations.BasicReceiver },
  { label: 'Receptor Avançado', value: AuthorizationRelations.AdvancedReceiver }
]

const PERMISSIONS_FOR_SELECT: PermissionOption[] = [
  { label: 'Proprietário', value: AuthorizationRelations.Parent, disabled: true },
  { label: 'Extrator', value: AuthorizationRelations.Extractor },
  { label: 'Emissor', value: AuthorizationRelations.Emitter },
  { label: 'Receptor Básico', value: AuthorizationRelations.BasicReceiver },
  { label: 'Receptor Avançado', value: AuthorizationRelations.AdvancedReceiver }
]

export class DsAttendanceStrategy implements ModuleTypeStrategy {
  getPermissionsForNewUsers(): PermissionOption[] {
    return PERMISSIONS_FOR_NEW_USERS
  }

  getPermissionsForSelect(): PermissionOption[] {
    return PERMISSIONS_FOR_SELECT
  }

  getDefaultPermission(): AuthorizationRelations {
    return AuthorizationRelations.Emitter
  }

  resolveResourceType(base: AuthorizationResourcesAndSubjects): AuthorizationResourcesAndSubjects {
    if (base === AuthorizationResourcesAndSubjects.Company)
      return AuthorizationResourcesAndSubjects.DsAttendanceCompany
    if (base === AuthorizationResourcesAndSubjects.HealthUnit)
      return AuthorizationResourcesAndSubjects.DsAttendanceHealthUnit
    return AuthorizationResourcesAndSubjects.DsAttendance
  }

  async addPermissions(
    resourceId: number,
    companyId: number,
    payload: UpsertPermissionsRequest,
    resourceType: AuthorizationResourcesAndSubjects
  ): Promise<void> {
    switch (resourceType) {
      case AuthorizationResourcesAndSubjects.DsAttendance:
        await Network.permission.addDsAttendancePermissions(resourceId, companyId, payload)
        break
      case AuthorizationResourcesAndSubjects.DsAttendanceCompany:
        await Network.permission.addDsAttendanceCompanyPermissions(resourceId, payload)
        break
      case AuthorizationResourcesAndSubjects.DsAttendanceHealthUnit:
        await Network.permission.addDsAttendanceHealthUnitPermissions(
          resourceId,
          companyId,
          payload
        )
        break
    }
  }

  async upsertPermissions(
    resourceId: number,
    companyId: number,
    payload: UpsertPermissionsRequest,
    resourceType: AuthorizationResourcesAndSubjects
  ): Promise<void> {
    switch (resourceType) {
      case AuthorizationResourcesAndSubjects.DsAttendance:
        await Network.permission.upsertDsAttendancePermissions(resourceId, companyId, payload)
        break
      case AuthorizationResourcesAndSubjects.DsAttendanceCompany:
        await Network.permission.upsertDsAttendanceCompanyPermissions(resourceId, payload)
        break
      case AuthorizationResourcesAndSubjects.DsAttendanceHealthUnit:
        await Network.permission.upsertDsAttendanceHealthUnitPermissions(
          resourceId,
          companyId,
          payload
        )
        break
    }
  }
}
